 /* ===========================================================
 * 
 *   ShadowBox Controller
 * 
 *   Manage the grid image shadowbox functionality
 * 
 *   Requires: jQuery
 * 
 * ===========================================================*/


$(function() {

    var showShadowBox = function( trigger ){
        
        $('html').addClass('shadowbox-open');

        url = $(trigger).attr('data-videourl');

        if (url) {
            $('.shadowbox-contents').html( '<video controls><source src="' + url + '">Sorry, your browser doesn\'t support embedded videos.</video>');
        }
    };

    var hideShadowBox = function(){
        $('html').removeClass('shadowbox-open');
        $('.shadowbox-contents').html( '');
        $('.shadowbox-caption').html( '');
    };

    var init = function() {

        $(document).on('click', '.js__open-shadowbox', function(){
            showShadowBox( this );        
        });

        $(document).on('keyup', function(e){
            if (e.keyCode === 27) {
                hideShadowBox();
            }
        });

        $(document).on('click', '.js__close-shadowbox', function(){
            hideShadowBox();
        });
    };

    init();

});
